import { create } from "zustand";

/**
 * Open state of the header's user menu (CockpitUserMenu), so the demo-data
 * badge can open it too. The header renders the menu twice (phone row and
 * wide layout); only the copy on screen shows its panel.
 */
export const useUserMenuUi = create<{ open: boolean; setOpen: (open: boolean) => void }>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
